import {css} from "@emotion/react";
import styled from "@emotion/styled";


export const Th = styled.th`
    border-bottom: 1px solid #6f6f6f;
    color: #2B2B2B;
    font-size: 14px;
    height: 31px;
    padding-left: 16px;
    padding-right: 16px;
`;

export const ThFlex = styled.div`
    display: flex;
    align-items: center;
`;

export const Td = styled.td`
    border-bottom: 1px solid rgba(112, 112, 112, 0.4);
    text-align: center;
    padding-left: 16px;
    padding-right: 16px;
`;
export const TdFlex = styled.div`
    color: #2b2b2b;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
`;

export const Tr = styled.tr`
    height: 31px;
`;

export const root = css`
    table-layout: fixed;
    & > tbody > tr {
        background-color: #F4F6FA;
    }
    & > tbody > tr:nth-of-type(2n) {
        background-color: white;
    }
    
`;

export const rootFullWidth = css`
    width: 100%;
`;